export default {
    Menu: 'Menü',
    Add: 'Hinzufügen',
    Modify: 'Bearbeiten',
    Delete: 'Löschen',
    Scale: 'Größe ändern',
    Color: 'Farbe',
    Materials: 'Materialien',
    Mesh: 'Netz',
    Size: 'Größe',
    Details: 'Details',
    Quantity: 'Menge',
    AddToCart: 'In den Warenkorb',
    AddToCartTitle: 'In den Warenkorb',
    Cart: 'Warenkorb',
    Total: 'Gesamt',
    Subtotal: 'Zwischensumme',
    Shipping: 'Versand',
    Shape: 'Form',
    PickShape: 'Wählen Sie eine Form zum Hinzufügen',
    ShapeAdded: 'Form hinzugefügt. Klicken Sie auf eine andere, um sie zu ersetzen.',
    Clipart: 'Illustration',
    PickClipart: 'Wählen Sie eine Illustration zum Hinzufügen',
    ClipartAdded: 'Illustration hinzugefügt. Klicken Sie auf eine andere, um sie zu ersetzen.',
    SearchClipart: 'Illustration suchen…',
    NoClipartFound: 'Keine Illustration gefunden',
    Cliparts: 'Cliparts',
    Illustration: 'Illustration',
    AiImage: 'KI-Bild',
    AiImageIntro: 'Beschreiben Sie, was Sie möchten, wählen Sie ein Format und erhalten Sie 2 Vorschläge.',
    AiImageFormat: 'Format',
    AiFormatSquare: 'Quadratisch',
    AiFormatPortrait: 'Hochformat',
    AiFormatLandscape: 'Querformat',
    AiImagePlaceholder: 'Z. B.: ein stilisierter Rotfuchs, flacher Stil, transparenter Hintergrund…',
    AiGenerate: 'Generieren',
    AiGenerating: 'Wird generiert…',
    AiPickResult: 'Wählen Sie einen Vorschlag',
    AiImageAdded: 'Bild zur Leinwand hinzugefügt',
    AiImageError: 'Bilderzeugung fehlgeschlagen',
    AiNoResult: 'Kein Bild generiert',
    AiImageNotInPlan:
        'Die KI-Bilderzeugung ist in Ihrem Tarif nicht enthalten. Aktivieren Sie die Option, um sie zu nutzen.',
    SearchIllustration: 'Illustration suchen…',
    NoIllustrationFound: 'Keine Illustration gefunden',
    IllustrationIntro: 'Suchen Sie nach Vektor-Illustrationen zum Hinzufügen.',
    IllustrationError: 'Suche nach Illustrationen fehlgeschlagen',
    IllustrationNotVector: 'Dieses Ergebnis ist kein verwertbarer Vektor',
    Texts: 'Texte',
    Images: 'Bilder',
    Colors: 'Farben',
    ThemeEditDesc: 'Bearbeiten Sie Texte, Bilder und Farben des Themes.',
    ThemeNotFound: 'Theme nicht gefunden.',
    ThemeNoEditable: 'Dieses Theme enthält keine bearbeitbaren Elemente.',
    Helpers: 'Lineale, Hilfslinien & Raster',
    Rulers: 'Lineale',
    RulersHint: 'Skala in Pixeln',
    Guides: 'Hilfslinien',
    GuidesHint: 'Markierungen bei 25 / 50 / 75 %',
    GridHint: 'Raster als Überlagerung',
    Snapping: 'Einrasten',
    SnappingHint: 'Richtet an Mitte / Raster / anderen Objekten aus',
    LeaveConfirm: 'Möchten Sie Ihre Änderungen wirklich verwerfen?',
    Products: 'Produkte',
    Customization: 'Personalisierung',
    BackToCustomizationType: 'Art der Personalisierung',
    SaveNoChanges: 'Keine Änderungen zum Speichern',
    ChooseCategory: 'Wählen Sie eine Kategorie',
    SelectProduct: 'Wählen Sie ein Produkt',
    Loading: 'Wird geladen',
    ProofLogoTooLarge: 'Logo zu groß (maximal 500 KB).',
    ProofLogoInvalidType: 'Nicht unterstütztes Bildformat.',
    ProofLogoImported: 'Logo importiert.',
    ProofLogoImportFailed: 'Logo-Import fehlgeschlagen.',
    YouHaveProjects: 'Sie haben {count} laufende(s) Projekt(e)',
    ResumeProject: 'Projekt fortsetzen',
    ResumeProjectHint: 'Machen Sie dort weiter, wo Sie aufgehört haben.',
    YourProjects: 'Ihre laufenden Projekte',
    OpenProject: 'Dieses Projekt öffnen',
    NoProjects: 'Keine laufenden Projekte.',
    AppUpdating: 'Anwendung wird aktualisiert…',
    DraftRestored: 'Entwurf wiederhergestellt',
    SaveExpiredTitle: 'Gespeichertes Projekt abgelaufen',
    SaveExpiredMessage: 'Dieses gespeicherte Projekt ist abgelaufen oder nicht mehr verfügbar.',
    Continue: 'Weiter',
    PhotoFramePickShape: 'Wählen Sie einen Rahmen',
    PhotoFramePlacePhoto: 'Foto platzieren und anpassen',
    PhotoFrameChangePhoto: 'Foto ändern',
    PhotoFrameDropTitle: 'Foto hier ablegen',
    PhotoFrameDropSub: 'oder zum Hochladen klicken',
    Rotation: 'Drehung',
    Reset: 'Zurücksetzen',
    ProofLogoTitle: 'Logo des Korrekturabzugs',
    ProofLogoUseSite: 'Logo von {site} behalten',
    ProofLogoUseMine: 'Mit meinem eigenen Logo',
    ProofLogoUseMineDesc: 'Nur auf dem Korrekturabzug, nicht auf den Druckdateien.',
    ProofLogoNone: 'Ohne Logo',
    ProofLogoDropTitle: 'Laden Sie Ihr Logo hoch',
    ProofLogoDropHint: 'PNG, JPG, WebP, SVG',
    LoadingValidation: 'Bestellung wird geprüft',
    LoadingStepScreenshots: 'Vorschauen werden erstellt',
    LoadingStepPrintFile: 'Druckdateien werden erstellt',
    LoadingStepUpload: 'Wird auf den Server hochgeladen',
    LoadingStepSave: 'Konfiguration wird gespeichert',
    LoadingGraduation: 'Skala wird geladen',
    OptimizingImage: 'Bild wird optimiert',
    LoadingScene: 'Szene wird geladen',
    LoadingStepZip: 'ZIP wird erstellt',
    LoadingProduct: 'Produkt wird geladen',
    Category: 'Kategorie',
    Product: 'Produkt',
    Summary: 'Übersicht',
    Zone: 'Zone',
    SelectZone: 'Zone auswählen',
    SelectAZone: 'Eine Zone wählen',
    Undo: 'Rückgängig',
    Redo: 'Wiederholen',
    Recenter: 'Ansicht zentrieren',
    HelpersIntro: 'Zonenränder, Raster, Lineale und Hilfslinien auf der 2D-Leinwand.',
    ShowZoneBordersHint: 'Zonenrahmen auf der Hauptleinwand',
    Save: 'Speichern',
    Saving: 'Wird gespeichert',
    Grid: 'Raster',
    SwitchTo3D: 'Zu 3D wechseln',
    PrintZone: 'Druckbereich',
    ViewModeSwitch: 'Anzeigemodus',
    ViewMode3D: '3D',
    ViewMode2D: '2D',
    ViewModeUI: 'UI',
    ViewModeDual: 'Doppelt',
    ShowZoneBorders: 'Zonenränder anzeigen',
    ShowZoneBordersHelp: 'Blendet die gepunkteten Ränder und Bezeichnungen der Zonen auf der 2D-Leinwand ein/aus.',
    ManageElements: 'Elemente verwalten',
    StartWithTheme: 'Mit einem Theme starten',
    Customize: 'Personalisieren',
    FromThemeLibrary: 'Aus unserer Theme-Bibliothek',
    StartFromScratch: 'Von Grund auf beginnen',
    Or: 'oder',
    PreviousCreations: 'Frühere Kreationen',
    WithModel: 'Mit einer Vorlage',
    Search: 'Suchen',
    SubCategory: 'Unterkategorie',
    Next: 'Weiter',
    Previous: 'Zurück',
    Validate: 'Bestätigen',
    DownloadMyProject: 'Mein Projekt herunterladen',
    EditThemeColors: 'Farben der Elemente bearbeiten',
    AddPattern: 'Hintergrund hinzufügen',
    EditGraduation: 'Abstufung bearbeiten',
    Pattern: 'Hintergrund',
    PatternHint: 'Das Muster wird über die gesamte Gestaltungsfläche wiederholt. Seine Farben sind anpassbar.',
    SearchTheme: 'Thema suchen (Titel oder Tag)',
    Theme: 'Theme',
    Graduation: 'Abstufung',
    Graduation_s: 'Abstufung(en)',
    ErrorOccurred: 'Ein Fehler ist aufgetreten.',
    ReloadPage: 'Bitte laden Sie die Seite neu.',
    LoadingCategories: 'Kategorien werden geladen',
    ShowAll: 'Alle anzeigen',
    Categories: 'Kategorien',
    ComingSoon: 'Bald verfügbar',
    DropImageHere: 'Bild hierher ziehen',
    ReleaseToImport: 'Loslassen zum Importieren',
    OrClickToBrowse: 'oder klicken zum Durchsuchen',
    AcceptedFormats: 'PNG, JPG, SVG, PDF, AI',
    VectorRecommendedForMethod:
        'Diese Druckmethode arbeitet mit festen Farben. Wir empfehlen vektorisierte Dateien für ein optimales Ergebnis.',
    SearchInPhotoGallery: 'In unserer Fotogalerie suchen',
    QrCode: 'QR-Code',
    QrCodeContent: 'Inhalt (URL, Text, E-Mail…)',
    QrCodePlaceholder: 'https://beispiel.com',
    QrCodeForeground: 'QR-Farbe',
    QrCodeBackground: 'Hintergrund',
    QrCodeTransparentBg: 'Transparenter Hintergrund',
    QrCodeErrorLevel: 'Fehlertoleranz',
    QrCodeErrorL: '7 % (niedrige Dichte)',
    QrCodeErrorM: '15 % (Standard)',
    QrCodeErrorQ: '25 %',
    QrCodeErrorH: '30 % (hoch)',
    QrCodeEmptyPreview: 'Geben Sie einen Inhalt für die Vorschau ein',
    QrCodeRequired: 'Der Inhalt des QR-Codes ist erforderlich.',
    QrCodeInvalidUrl: 'Geben Sie eine gültige QR-Code-URL ein (http:// oder https://).',
    QrCodeAdd: 'QR-Code hinzufügen',
    QrCodeEditOnlyColors:
        'Nach dem Erstellen eines QR-Codes können nur die Farben geändert werden. Um den Inhalt zu ändern, löschen Sie ihn und erstellen Sie einen neuen.',
    ImageQualityGood: 'Gute Auflösung',
    ImageQualityMedium: 'Mittlere Auflösung',
    ImageQualityLow: 'Niedrige Auflösung – vergrößern Sie das Bild oder verkleinern Sie es auf der Leinwand',
    LowQualityAlertTitle: 'Achtung',
    LowQualityAlertMessage:
        'Ihre Kreation enthält Bilder von niedriger Qualität oder solche, die zu stark im Verhältnis zu ihrer ursprünglichen Auflösung vergrößert wurden. Korrigieren Sie Ihre Kreation oder akzeptieren Sie das Risiko der Pixelbildung beim Druck.',
    LowQualityAlertHint: 'Schwelle für niedrige Auflösung:',
    LowQualityAcceptRisk: 'Ich akzeptiere das Risiko der Pixelbildung für meine Bilder niedriger Qualität',
    Preview: 'Vorschau',
    Bold: 'Fett',
    Italic: 'Kursiv',
    Underline: 'Unterstrichen',
    FontSize: 'Größe',
    SelectFont: 'Schriftart wählen',
    UploadFont: 'Eigene Schrift hochladen',
    UploadFontHint: 'TTF oder OTF · max. 5 MB',
    CustomFontBadge: 'eigene',
    CustomFontImported: 'Schrift importiert.',
    CustomFontFormatError: 'Format nicht unterstützt (nur TTF oder OTF).',
    CustomFontTooLarge: 'Schrift zu groß (max. 5 MB).',
    CustomFontImportFailed: 'Schriftimport fehlgeschlagen.',
    CustomFontRemoved: 'Schrift entfernt.',
    RecentFonts: 'Zuletzt',
    Clear: 'Löschen',
    TextColor: 'Textfarbe',
    TextOutline: 'Kontur',
    AddOutline: 'Kontur hinzufügen',
    RemoveOutline: 'Kontur entfernen',
    PickColor: 'Farbe wählen',
    PickThemeCategory: 'Wählen Sie eine Kategorie, um Themes zu entdecken',
    NoThemeInCategory: 'Kein Theme in dieser Kategorie',
    ThemePreviewLabel: 'Theme-Vorschau',
    PickAnotherTheme: 'Ein anderes Theme wählen',
    Keep: 'Behalten',
    LoadingThemes: 'Themes werden geladen',
    LoadingPatterns: 'Hintergründe werden geladen',
    EditableThemeColors: 'Bearbeitbare Farben der Elemente',
    PickAColor: 'Wählen Sie eine Farbe',
    SelectALayout: 'Wählen Sie eine Vorlage',
    CreateLayer: 'Element erstellen',
    LastDownloads: 'Letzte Downloads',
    Cancel: 'Abbrechen',
    Back: 'Zurück',
    BackToProvider: 'Zurück zu {provider}',
    LayerNotFound: 'Das Element wurde nicht gefunden',
    ChangeImage: 'Bild ändern',
    ChangePattern: 'Hintergrund ändern',
    Resize: 'Größe ändern',
    RemoveBackground: 'Freistellen',
    Processing: 'Wird verarbeitet…',
    AddFilter: 'Filter hinzufügen',
    PhotoCredit: 'Foto von {author} auf {provider}',
    PhotoBy: 'Foto von',
    On: 'auf',
    LinkRedirectionWarning: 'Dieser Link leitet Sie zu dieser Website weiter',
    LoadMore: 'Mehr laden',
    EditLayer: 'Element bearbeiten',
    Import: 'Importieren',
    FromYourDevice: 'Von Ihrem Gerät',
    FromImageGallery: 'Aus der Bildergalerie',
    NoGraduationsAvailable: 'Keine Abstufung verfügbar',
    Confirm: 'Bestätigen',
    CustomizeProduct: 'Personalisieren Sie Ihr Produkt',
    WriteYourText: 'Schreiben Sie hier Ihren Text',
    Text: 'Text',
    Image: 'Bild',
    DesignSummary: 'Zusammenfassung Ihres Designs',
    AddOptions: 'Optionen hinzufügen',
    TermsOfSale: 'Allgemeine Geschäftsbedingungen',
    TOSMessage:
        'Ich bestätige, dass meine Kreation den [Allgemeinen Geschäftsbedingungen](#) entspricht, insbesondere Artikel 8 – Geistiges Eigentum',
    IValidateMyCreation: 'Ich bestätige meine Kreation',
    FunctionalityNotAvailable: 'Funktion nicht verfügbar',
    Lock: 'Sperren',
    Unlock: 'Entsperren',
    AddLayer: 'Element hinzufügen',
    LayerSectionTemplates: 'Vorlagen',
    LayerSectionText: 'Text & Daten',
    LayerSectionImages: 'Bilder',
    LayerSectionDecor: 'Dekor',
    LayerSectionTools: 'Werkzeuge',
    DragLayersToReorder: 'Ziehen Sie die Ebenen, um sie neu anzuordnen',
    PleaseAgreeTOS: 'Bitte akzeptieren Sie die AGB, um Ihre Kreation zu bestätigen.',
    ErrorExportPrintFile: 'Beim Export der Druckdatei ist ein Fehler aufgetreten.',
    ErrorExportProofFile: 'Beim Export des Korrekturabzugs ist ein Fehler aufgetreten.',
    ErrorAddToCart: 'Beim Hinzufügen zum Warenkorb ist ein Fehler aufgetreten: ',
    Gabarit: 'Schablone',
    FicheTechnique: 'Datenblatt',
    GeneratingPrintFile: 'Druckdatei wird erstellt…',
    GeneratingProofFile: 'Korrekturabzug wird erstellt…',
    LeaveCustomizer: 'Konfigurator verlassen',
    LeaveManager: 'Elementverwaltung verlassen',
    ChangeProductTitle: 'Ihre Kreation wird gelöscht.',
    ChangeProductConfirm: 'Ein Produktwechsel löscht Ihre Kreation endgültig. Sind Sie sicher?',
    Duplicate: 'Duplizieren',
    LoadingTheme: 'Theme wird geladen',
    LoadingPattern: 'Hintergrund wird geladen',
    Expand: 'Vergrößern',
    Shrink: 'Verkleinern',
    TiltLeft: 'Nach links neigen',
    TiltRight: 'Nach rechts neigen',
    Rotate: 'Drehen',
    Move: 'Verschieben',
    Reposition: 'Neu positionieren',
    MoveUp: 'Nach oben verschieben',
    MoveDown: 'Nach unten verschieben',
    MoveLeft: 'Nach links verschieben',
    MoveRight: 'Nach rechts verschieben',
    NoCustomization: 'Auf dem Produkt gibt es keine Personalisierung.',
    MissingCustomization: 'Fehlende Personalisierung',
    SelectGraduation: 'Wählen Sie eine Abstufung',
    ProofTitle: 'Korrekturabzug',
    ProofDesignTitle: '2D-Personalisierung',
    ProofScreenshotsTitle: '3D-Ansichten',
    ProofSelectedInksTitle: 'Ausgewählte Farben',
    Warning: 'Achtung',
    SelectZoneBeforeTheme: 'Bitte wählen Sie eine Zone, bevor Sie ein Theme wählen.',
    ThemeTooManyElements: 'Das Theme enthält zu viele Elemente. Bitte wählen Sie ein anderes',
    Error: 'Fehler',
    ProductNotFound: 'Produkt nicht gefunden',
    ProductNotFoundMessage: 'Produkt nicht gefunden, Sie werden zur Startseite weitergeleitet.',
    NoCategoryAvailable: 'Keine Kategorie verfügbar',
    CategoryNotFound: 'Kategorie nicht gefunden',
    CategoryNotFoundMessage: 'Kategorie nicht gefunden, Sie werden zur Startseite weitergeleitet.',
    Unavailable: 'Nicht verfügbar',
    SavedConfigurations: 'Gespeicherte Konfigurationen',
    YourSavedConfigurations: 'Ihre gespeicherten Konfigurationen',
    NoSavedConfigurations: 'Keine gespeicherte Konfiguration für dieses Produkt',
    ConfigurationName: 'Name der Konfiguration',
    Created: 'Erstellt',
    Expires: 'Läuft ab',
    Load: 'Laden',
    ConfirmDeleteConfiguration: 'Möchten Sie diese Konfiguration wirklich löschen?',
    Close: 'Schließen',
    Step: 'Schritt',
    CustomizeProductDesc: 'Wählen Sie, wie Sie beginnen: freie Gestaltung oder mit einem unten vorgeschlagenen Theme.',
    StartFromScratchDesc: 'Eine leere Leinwand für Texte, Bilder und Formen, ohne vorgegebene Vorlage.',
    ChooseProductDesc: 'Wählen Sie ein Produkt zum Personalisieren.',
    PrintMethod: 'Druckmethode',
    ChoosePrintMethod: 'Wählen Sie Ihre Methode',
    ChoosePrintMethodDesc:
        'Wählen Sie die Druckmethode für dieses Produkt. Diese Wahl ist für diese Personalisierung endgültig.',
    Digital: 'Digital',
    ScreenPrinting: 'Siebdruck',
    LaserEngraving: 'Lasergravur',
    Embroidery: 'Stickerei',
    RestrictedToPalette: 'Auf die Palette beschränkte Farben',
    ChooseInks: 'Wählen Sie Ihre Farben',
    ChooseThreads: 'Wählen Sie Ihre Garne',
    AppliesToZone: 'Zone: {zone}',
    Ink: 'Farbe',
    Thread: 'Garn',
    InkOverride: 'Farbe erzwingen',
    ThreadOverride: 'Garn erzwingen',
    SuggestInks: 'Vorgeschlagene Farben',
    SuggestThreads: 'Vorgeschlagene Garne',
    RecommendColorsFromImage: 'Farben aus dem Bild empfehlen',
    NoColorSuggestion: 'Kein Farbvorschlag für dieses Bild.',
    InkAssistantHelp: 'Diese Methode verwendet eine Palette von {count} festen Farben.',
    InkAssistantQuestion: 'Wie möchten Sie Ihre Farben festlegen?',
    InkAssistantUpload: 'Hilf mir, meine Farben zu finden',
    InkAssistantUploadDesc:
        'Laden Sie Ihr Bild, Logo oder Muster hoch – wir erkennen automatisch die nächstgelegenen Palettenfarben.',
    InkAssistantManual: 'Ich wähle meine Farben manuell',
    InkAssistantManualDesc: 'Wählen Sie jede Farbe einzeln aus der Palette.',
    InkAssistantAnalyzing: 'Ihr Bild wird analysiert…',
    InkChoiceModifiableHint: 'Diese Wahl kann jederzeit geändert werden.',
    InkAssistantResultDesc: 'Hier sind die Palettenfarben, die Ihrem Bild am nächsten kommen.',
    InkDuplicateWarning:
        'Diese Farbe ist bereits für eine andere Farbe/ein anderes Garn ausgewählt. Eine zweite Auswahl fügt die Farben endgültig zusammen! Sind Sie sicher?',
    Selected: 'Ausgewählt',
    VectorizeImage: 'Bild vektorisieren',
    Vectorizing: 'Wird vektorisiert…',
    VectorizePreviewTitle: 'Ergebnis der Vektorisierung',
    VectorizeIntro:
        'Das Bild wird in einen Vektor umgewandelt und auf die gewählten Farben beschränkt. Bestätigen Sie das Ergebnis, um es anzuwenden.',
    VectorizeApply: 'Vektor anwenden',
    VectorizeConsent:
        'Ich verstehe, dass ich für die Kontrolle des Vektorisierungsergebnisses verantwortlich bin und dass der Druck dieses widerspiegelt.',
    VectorizeThreshold: 'Schwelle (Detail / Hintergrund)',
    VectorizeThresholdHint:
        'Passen Sie die Schwelle an: niedriger entfernt mehr hellen Hintergrund (Strichzeichnung); höher behält mehr helle Bereiche.',
    VectorizeCancel: 'Abbrechen',
    VectorizeFailed: 'Die Vektorisierung ist fehlgeschlagen. Versuchen Sie es erneut oder wählen Sie ein anderes Bild.',
    Before: 'Vorher',
    After: 'Nachher',
    VariableText: 'Variabler Text',
    VariableTextIntro:
        'Diese Funktion ähnelt einem Serienbrief und liefert Ihr Produkt in einem einzigen Exemplar pro Text; die Menge wird automatisch für Ihren Warenkorb berechnet.',
    VariableTextData: 'Daten (eine Zeile = ein Exemplar)',
    VariableTextPlaceholder: 'Jean Dupont\nMarie Martin\nPaul Bernard',
    VariableTextImport: 'CSV / Excel importieren',
    SessionImages: 'Importierte Bilder',
    Accept: 'Akzeptieren',
    UploadConsentMessage:
        'Ich bestätige, dass keine meiner Dateien geltende Gesetze, Urheberrechte oder Rechte Dritter verletzt.',
    VariableTextNoData: 'Fügen Sie mindestens eine Zeile für die Vorschau hinzu.',
    VdpFields: 'Variable Felder',
    VdpFieldName: 'Feldname',
    VdpPlace: 'Platzieren',
    VdpPlaced: 'Platziert',
    VdpAddField: 'Feld hinzufügen',
    VdpAddRow: 'Zeile hinzufügen',
    VdpLine: 'Zeile',
    VdpEnterData: 'Meine Daten eingeben',
    Done: 'Fertig',
    VdpFieldStyle: 'Feldstil',
    VdpFirstRowHeader: '1. Zeile = Kopfzeile (Feldnamen)',
    VdpQuantity: 'Menge: {qty}',
    VdpQuantityHint: 'Die Menge ergibt sich aus der Anzahl der Zeilen Ihres variablen Textes.',
    VariableTextOnlyOne: 'Nur ein Feld für variablen Text pro Kreation.',
    VariableTextEmptyFile: 'Leere Datei oder ohne verwertbare Spalte.',
    VariableTextImportError:
        'Diese Datei kann nicht gelesen werden. Verwenden Sie eine CSV oder fügen Sie den Text ein.',
    VariableTextExcelUnavailable: 'Excel-Lesen nicht verfügbar. Exportieren Sie als CSV oder fügen Sie den Text ein.',
    InkAuto: 'Auto',
    PreflightScreenMissingInks:
        'Ausgewählte Farben: {chosen}/{required}. Wählen Sie alle Farben, bevor Sie bestätigen.',
    PreflightScreenColorCount: 'Siebdruck: Ihre Kreation ist auf {count} Farbe(n) beschränkt.',
    PreflightMinStroke: 'Empfohlene Mindeststrichstärke: {mm} mm. Feinere Striche können schlecht drucken.',
    PreflightMinFont: 'Empfohlene Mindestschriftgröße: {pt} pt.',
    PreflightLaserMonochrome: 'Lasergravur: das Endergebnis ist einfarbig.',
    More: 'Weitere',
    All: 'Alle',
    AllCategories: 'Alle Kategorien',
    SearchCategory: 'Kategorie suchen…',
    NoProductAvailable: 'Kein Produkt in dieser Kategorie.',
    ChooseProductTitle: 'Wähle dein Produkt zum Personalisieren',
    PrintMethodQuestion: 'Wie möchtest du dein {product} bedrucken?',
    PrintMethodIntro:
        'Jede Methode hat ihre Stärken und Einschränkungen – sie bestimmt die danach verfügbaren Farben und Ergebnisse.',
    StartLabel: 'Ausgangspunkt',
    StartTitle: 'Starte mit einem Theme oder einer leeren Seite',
    StartIntro: 'Ein Theme = ein fertiges Design zum Anpassen (am schnellsten). Leere Seite = volle Kontrolle.',
    StepProduct: 'Produkt',
    StepMethod: 'Methode',
    StepStart: 'Start',
    StepDesign: 'Design',
    ChangeTheme: 'Theme wechseln',
    BackToTheme: 'Zurück zum Theme',
    Recent: 'Zuletzt verwendet',
    WhiteNotPrintable: 'Weiß kann nicht gedruckt werden (transparent).',
    LoginToSave: 'Melden Sie sich an, um Ihre Designs in Ihrem Konto wiederzufinden.',
    Login: 'Anmelden',
    LoggingIn: 'Anmeldung…',
    ContinueWithoutAccount: 'Ohne Konto fortfahren',
    SaveEmailPlaceholder: 'Ihre E-Mail-Adresse',
    SaveEmailHint: 'Sie erhalten einen Link, um Ihr Projekt fortzusetzen (30 Tage gespeichert).',
    SaveConfirmTitle: 'Projekt gespeichert',
    SaveConfirmMessage:
        'Ihr Projekt wurde gespeichert. Eine E-Mail mit dem Fortsetzungslink wurde soeben an Sie gesendet.',
    DisableEmbroideryEffect: 'Stickeffekt deaktivieren',
    AddThread: 'Faden hinzufügen',
    RemoveThread: 'Faden entfernen',
    VectorizeDenoise: 'Rauschen reduzieren',
    VectorizeDenoiseHint: 'Entfernt Flecken und kleine Störpunkte.',
    VectorizeSmoothing: 'Glättung',
    VectorizeSmoothingHint: 'Rundet die Konturen ab (weniger Ecken).',
    ZoomIn: 'Vergrößern',
    ZoomOut: 'Verkleinern',
    Fit: 'Einpassen',
    Apply: 'Anwenden',
    Edit: 'Bearbeiten',
    Support: 'Support',
    VectorizeAcknowledge:
        'Ich verstehe, dass ich für die Prüfung des Vektorisierungsergebnisses verantwortlich bin und der Druck dieses widerspiegelt.',
    Crop: 'Zuschneiden',
    Font: 'Schriftart',
    Style: 'Stil',
    Outline: 'Kontur',
    Steps: 'Schritte',
    Tools: 'Werkzeuge',
    ThemeColors: 'Farben',
    Minimize: 'Verkleinern',
    MoveLayerUp: 'Ebene nach oben',
    MoveLayerDown: 'Ebene nach unten',
    DragLayer: 'Ziehen zum Neuordnen',
    NoResult: 'Kein Ergebnis',
    SearchElement: 'Element suchen…',
    ExpertMode: 'Expertenmodus',
    Finish: 'Fertigstellen',
    ChooseImageOrPhoto: 'Bild oder Foto auswählen',
    WizardIntro: 'Folgen Sie den Schritten für eine personalisierte Gestaltung in 1 Minute.',
    WizardIntroExpert: 'Möchten Sie mehr Freiheit? Wechseln Sie in den Expertenmodus.',
    ClickToChooseImage: 'Hier klicken, um ein Bild oder Foto auszuwählen',
    ChooseCategoryDesc: 'Wählen Sie eine Produktfamilie, um zu beginnen.',
    SelectProductDesc: 'Wählen Sie ein Produkt, um zu beginnen…',
    FinalReview: 'Letzter Schritt',
    StartWithThemeDesc: 'Starten Sie mit einem vorkonfigurierten Design.',
    WithModelDesc: 'Wählen Sie eine fertige Vorlage.',
    ExpertModeConfirmTitle: 'Expertenmodus',
    ExpertModeConfirmMsg:
        'Der Wechsel in den Expertenmodus ist eine endgültige Entscheidung. Dieser Modus ist etwas komplexer zu bedienen, ermöglicht aber das Hinzufügen und Bearbeiten von Elementen ohne Einschränkungen.',
    ExpertModeHint: 'Vervollständigen Sie Ihr Design ohne Grenzen – fügen Sie Texte und Fotos nach Belieben hinzu.',
    VariableData: 'Variable Daten',
    PhotoFrame: 'Fotorahmen',
    PhotoFrameHint: 'Wählen Sie eine Form und setzen Sie dann ein Foto ein.',
    PhotoFrameChooseShape: '1. Rahmenform',
    PhotoFrameChangeShape: 'Form ändern',
    PhotoFramePickPhoto: 'Foto auswählen',
    FromLibrary: 'Aus der Bibliothek',
    VdpMaxRowsReached: 'Maximaler Bestand erreicht',
    VdpImportTruncated: 'Import auf verfügbaren Bestand begrenzt',
    LetterSpacing: 'Zeichenabstand',
    OutlineActive: 'Kontur aktiviert',
    OutlineThickness: 'Konturstärke',
    AlignLeft: 'Linksbündig',
    AlignCenter: 'Zentrieren',
    AlignRight: 'Rechtsbündig',
    Uppercase: 'Großbuchstaben',
    TextFormatting: 'Formatierung',
    FontSizeLabel: 'Schriftgröße',
    SelectionActions: 'Aktionen für Auswahl',
    DragToMove: 'Ziehen zum Verschieben',
    DragToResize: 'Ziehen zum Skalieren',
    DragToRotate: 'Ziehen zum Drehen',
    MoveUpOneLevel: 'Eine Ebene nach oben',
    MoveDownOneLevel: 'Eine Ebene nach unten',
    BringToFront: 'In den Vordergrund',
    Front: 'Vordergrund',
    SendToBack: 'In den Hintergrund',
    BackgroundNeverUnderPattern: 'Hintergrund (nie unter einem Hintergrundmuster)',
    EyedropperColor: 'Farbpipette',
    PresetColors: 'Voreingestellte Farben',
    RecentColors: 'Zuletzt verwendete Farben',
    Palette: 'Palette',
    HexValue: 'Hex-Wert',
    AiResultsHint: 'Alle Vorschläge findest du im Reiter Bild',
    Notifications: 'Benachrichtigungen',
    Zoom: 'Zoom',
    GuidedCustomization: 'Geführte Gestaltung',
    Actions: 'Aktionen',
    InkAssistantYourChoice: 'Ihre Wahl:',
    InkAssistantCorrectQuestion: 'Möchten Sie diese Auswahl ändern?',
    ZonePrices: 'Preis pro Zone',
    ZonePriceApplied: 'Angewendet',
    ZonePriceUncovered: 'Keine Option deckt alle gestalteten Zonen ab.',
    ZonePricesShow: 'Anzeigen',
    ZonePricesHide: 'Ausblenden',
    '': ''
};
